import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import DangerouslySetInnerHTML from "@src/components/DangerouslySetInnerHTML"
import { useTranslation } from "react-i18next"

const BodySection = ({ content }) => {
  const {t} = useTranslation()
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
    >
      <Stack gap="24px" direction="column">
        <Typography fontSize="30px" fontWeight={700} lineHeight="38px">
          {t('introduction')}
        </Typography>
        <Box maxWidth="652px">
          <DangerouslySetInnerHTML html={content} />
        </Box>
      </Stack>
    </Stack>
  )
}

export default BodySection
